<script>
import { dataLayerEvent } from '@utils/data-layer.js';
import UiButton from "@components/ui/ui-button/ui-button.vue";

export default {
    name: "OneTimeReports",
    components: {UiButton},
    props: {
        position: {
            type: String,
            required: true,
        }
    },
    methods: {
        buttonClickEvent() {
            dataLayerEvent({
                eventId: 9,
                event: 'vntGeo',
                eventCategory: 'glavnaya',
                eventLabel: 'ostavit_zayavku',
                eventAction: 'element_click',
                buttonLocation: 'question'
            });
        }
    }
}
</script>

<template>
    <div id="one-time-report" class="one-time-report">

        <div class="one-time-report__content">
            <h3 class="title">Отчёт по адресу за минуту</h3>
            <div class="content-body">
                <p class="content-body__description">
                    Закажите быструю аналитику точки за <span class="strong">500 руб</span> в pdf формате
                </p>
                <UiButton
                    size="medium"
                    color="primary"
                    href="https://system.geoeffect.ru/fast-order"
                >
                    Заказать отчёт
                </UiButton>
            </div>
        </div>
        <div v-if="position === 'top'" class="one-time-report__image top" />
        <div v-if="position === 'bottom'" class="one-time-report__image bottom" />
    </div>
</template>

<style lang="scss">
@import "@design/colors.scss";
@import "@design/mixins.scss";
    .one-time-report {
        max-width: 1280px;
        display: flex;
        background-image: url('#{$VUE_APP_BASE}/assets/images/landing/backgrounds/background-alter.webp');
        background-size: cover;
        background-position: center;
        border-radius: 40px;
        margin: 0 auto;
        @include tablet {
            max-width: 100%;
            margin: 60px 40px;
            position: relative;
            flex-direction: column-reverse;
        }
        @include mobile {
            margin: 40px 20px;
        }
        .one-time-report__content {
            flex: 1;
            padding: 60px 100px 60px 60px;

            @include tablet {
                padding: 40px;
            }

            @include mobile {
                padding: 24px 20px 20px;
            }

            .title {
                color: $white-text;
                font-family: "MTS Wide";
                font-size: 36px;
                font-style: normal;
                font-weight: 500;
                line-height: 40px;
                margin-bottom: 16px;

                @include mobile {
                    font-size: 28px;
                    margin-bottom: 0;
                }
            }

            .content-body {
                .content-body__description, .content-body__description>span {
                    color: $white-text;
                    font-family: "MTS Compact";
                    font-size: 17px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                    margin-bottom: 32px;

                    @include mobile {
                        margin-bottom: 16px;
                    }

                    .strong {
                        font-weight: 700;
                    }
                }
            }

        }
        .one-time-report__image {
            flex-grow: 1.3;
            flex-shrink: 0;
            height: 400px;
            background-image: url('#{$VUE_APP_BASE}/assets/images/landing/one-time-report/fastOrder-landing-desktop-1.webp');
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;

            @include tablet {
                height: 388px;
            }
            @include mobile {
                height: 180px;
            }

            &.top {
                background-image: url('#{$VUE_APP_BASE}/assets/images/landing/one-time-report/fastOrder-landing-desktop-1.webp');
                @include tablet {
                    background-image: url('#{$VUE_APP_BASE}/assets/images/landing/one-time-report/fastOrder-landing-tablet-1.webp');
                }
            }

            &.bottom {
                background-image: url('#{$VUE_APP_BASE}/assets/images/landing/one-time-report/fastOrder-landing-desktop-2.webp');
                @include tablet {
                    background-image: url('#{$VUE_APP_BASE}/assets/images/landing/one-time-report/fastOrder-landing-tablet-2.webp');
                }
            }
        }
    }
</style>